<template>
  <div class="search-container clearable">
    <b-field label="Search" expanded>
      <b-input
        placeholder="Search KYC Forms by company name or job number"
        v-model.trim="searchValue"
        @keyup.native="searchInput"
        :loading="$store.state.isSearching"
      ></b-input>
    </b-field>
    <div>
      <span class="clearable__clear"
        @click="clearSearch"
        v-if="searchValue && $store.state.searched"
      >&times;</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'KycSearch',
  data () {
    return {
      timeoutHandler: null,
      searchValue: null
    }
  },
  methods: {
    searchInput (e) {
      clearTimeout(this.timeoutHandler)
      if (!this.searchValue || this.searchValue.length === 0) {
        this.clearSearch()
      } else {
        this.$store.dispatch('setIsSearching', { isSearching: true })
        this.$store.dispatch('setSearched', { searched: false })
        this.timeoutHandler = setTimeout(_ => {
          this.$store.dispatch('setSearchQuery', { q: this.searchValue.trim() })
          this.$store.dispatch('searchKyc', { page: 1 })
        }, 1000)
      }
    },
    clearSearch () {
      this.searchValue = null
      this.$store.dispatch('clearKyc')
      this.$store.dispatch('clearTotalForms')
      this.$store.dispatch('clearSearchQuery')
      this.$store.dispatch('setNoSearchResults', { noSearchResults: false })
      this.$store.dispatch('setSearched', { searched: false })
      this.$store.dispatch('setIsSearching', { isSearching: false })

      this.$store.dispatch('getKycList')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.search-container {
  width: 100%;
  margin-right: 1em;
}

.clearable {
  position: relative;
}

.clearable__clear {
  position: absolute;
  right: 0;
  top: 1.8em;
  padding: 0 8px;
  font-style: normal;
  font-size: 1.2em;
  user-select: none;
  cursor: pointer;
}

</style>
